export default "__VITE_ASSET__CwLQbg0j__"